import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import App from './App.vue'
import ConstantsPlugin from './plugins/const'

Vue.use(ElementUI)
Vue.use(ConstantsPlugin)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
